import { NgModule } from '@angular/core';

import { BaseModule } from '../../base.module';

import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import { MATERIALS } from '../../../app.materials';
import { DynamicReportPieChartComponent } from './pie-chart.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

@NgModule({
    imports: [
        MATERIALS,
        BaseModule,
        BsDropdownModule.forRoot(),
        TooltipModule.forRoot(),
        TypeaheadModule.forRoot(),
    ],
    exports: [
        DynamicReportPieChartComponent
    ],
    declarations: [DynamicReportPieChartComponent]
})

export class DynamicReportPieChartModule { }
